/** Normaliza respuestas paginadas del API (data + meta). */
export function normalizePagedApiResponse<T>(response: unknown): {
  items: T[];
  totalPages: number;
} {
  const res = response as Record<string, unknown> | null | undefined;
  const data = Array.isArray(res?.data)
    ? (res?.data as T[])
    : Array.isArray(res)
      ? (res as T[])
      : [];
  const meta = res?.meta as Record<string, number> | undefined;
  const pagination = res?.pagination as Record<string, number> | undefined;
  const totalPages = Math.max(
    1,
    meta?.totalPages ?? pagination?.totalPages ?? (data.length > 0 ? 1 : 1),
  );
  return { items: data, totalPages };
}
